/**
 * <summary>
 * UploadTempaltes page lets store view and choose the Headquarter before and after templates in medical records.
 * fetches data, handles form submission, and shows success or error toasts.
 * Developer: Pratiksha Sharma
 * </summary>
 */
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { observer } from "mobx-react-lite";
import { FormattedMessage } from "react-intl";
import { useStore } from "../../contexts/store-provider";
import LanguageSlider from "../../shared-components/language-slider/language-slider";
import {
  getBusinessTypeIdFromLocalStorage,
  getHeadquarterIdFromLocalStorage,
} from "../../helpers/localstorage-helper";
import AddEditCancelationPolicyForm from "./forms/add-edit-cancelation-policy";
import { IUpdateHeadquarterCancelationPolicy } from "../../models/response/IHeadquarterResponse";
import FormLoader from "../../shared-components/FormLoader/FormLoader";

const CancelationPolicy = () => {
  const { headquarterStore } = useStore();
  const {
    headquarterDetails,
    UpdateCancelationHeadquarterService,
    addUpdateHeadquartertState,
    GetHeadquarterByIdService,
    GetHeadquarterCancelationDetail,
    hqCancellationPolicyDetailsState,
    getHeadquartertByIdState,
    headquarterCancelationPolicyDetails,
    addUpdateHeadquarterCancelationPolicyState,
    resetAddUpdateHeadquarterCancelation,
    setDisableAction,
    disableAction
  } = headquarterStore;

  const HeadquaterId = getHeadquarterIdFromLocalStorage();

  const isUpdateMode = headquarterDetails?.Id > 0;

  useEffect(() => {
    if (HeadquaterId > 0) {
      GetHeadquarterByIdService(HeadquaterId);
      GetHeadquarterCancelationDetail(HeadquaterId);
      return(()=>{
        setDisableAction(false);
      })
    }
  }, [HeadquaterId]);

  // useEffect(() => {
  //   return(()=>{
  //     resetHeadquarterCancelationPolicyState();
  //   });
  // }, []);

  useEffect(() => {
    if (addUpdateHeadquarterCancelationPolicyState.success) {
      toast.success(<FormattedMessage id={"updated_success"} />);
      GetHeadquarterCancelationDetail(HeadquaterId);
      resetAddUpdateHeadquarterCancelation();
    }
  }, [addUpdateHeadquarterCancelationPolicyState.success]);

  useEffect(() => {
    if (addUpdateHeadquarterCancelationPolicyState.error) {
      toast.error(
        <FormattedMessage
          id={addUpdateHeadquarterCancelationPolicyState.error}
        />
      );
    }
  }, [addUpdateHeadquarterCancelationPolicyState.error]);

  const submitHandler = (data: IUpdateHeadquarterCancelationPolicy) => {
    const updateObj = {
      Id: data.Id,
      HeadquarterCancelationPolicy: data.HeadquarterCancelationPolicy,
      HeadquarterCancelationText: data.HeadquarterCancelationText,
      ShowOnFilter: data.ShowOnFilter,
      BusinessTypeId: getBusinessTypeIdFromLocalStorage(),
    };
    UpdateCancelationHeadquarterService(updateObj);
  };

  return (
    <>
      {(hqCancellationPolicyDetailsState.inProgress ||
        getHeadquartertByIdState.inProgress ||
        addUpdateHeadquarterCancelationPolicyState.inProgress) && (
        <FormLoader
          loading={
            hqCancellationPolicyDetailsState.inProgress ||
            getHeadquartertByIdState.inProgress ||
            addUpdateHeadquarterCancelationPolicyState.inProgress
          }
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="cancelation_policy" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="various_settings" />
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <FormattedMessage id="cancelation_policy" />
                </li>
              </ol>
            </div>
          </div>
          <div className="col-6">
            <ul className="add-list">
              <li>
                <LanguageSlider />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container-fluid mt-4 p-0">
        <div className="row align-items-center justify-content-center">
          <div className="col-md-9 col-12">
            <div className="card">
              <div className="card-header p-3">
                <h3 className="card-title mb-0">
                  <FormattedMessage id="cancelation_policy" />
                </h3>
              </div>
              <div className="card-body">
                <AddEditCancelationPolicyForm
                  id={HeadquaterId}
                  initialValues={headquarterCancelationPolicyDetails}
                  submitHandler={submitHandler}
                  loading={addUpdateHeadquartertState.inProgress}
                  isUpdateMode={isUpdateMode}
                  disableAction={disableAction}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(CancelationPolicy);
